import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {isTeammateNamespace} from '../../helpers/models/namespaceHelpers';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../helpers/reselectHelpers';
import {SettingsAnswersUrl} from '../../models/url/settingsUrlModel';
import {AppState} from '../../store/appState';
import {getFindShouldDisplayInfoBox} from '../../store/data/localPreferences/localPreferencesSelectors';
import {SettingsPanelId} from '../../store/panels/panelStateBase';
import {navigateToLinkAction} from '../../store/stateless/navigationActions';
import {SettingsAnswers} from './settingsAnswers';

/*
 * Props.
 */

interface SettingsAnswersContainerProps {
  panelId: SettingsPanelId;
  url: SettingsAnswersUrl;
}

/*
 * Selectors.
 */

function getUrl(_state: AppState, props: SettingsAnswersContainerProps) {
  return props.url;
}

const getInfoBoxId = createSelector(getUrl, (url) =>
  isTeammateNamespace(url.namespace) ? 'individual_message_templates' : 'team_message_templates',
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsAnswersContainerProps>()(() => ({
  findShouldDisplayInfoBox: getFindShouldDisplayInfoBox,
  infoBoxId: getInfoBoxId,
}));
const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  navigateToLink: navigateToLinkAction,
}));

export const SettingsAnswersContainer = connect(mapStateToProps, mapDispatchToProps)(SettingsAnswers);
